/* tslint:disable */
/* eslint-disable */
/* @relayHash 5ccd2507dbaf49d46e357ff0b303d057 */

import { ConcreteRequest } from "relay-runtime";
export type UploadFiles_RemoveMutationVariables = {
    uuid: string;
};
export type UploadFiles_RemoveMutationResponse = {
    readonly removeFileToVerify: boolean;
};
export type UploadFiles_RemoveMutation = {
    readonly response: UploadFiles_RemoveMutationResponse;
    readonly variables: UploadFiles_RemoveMutationVariables;
};



/*
mutation UploadFiles_RemoveMutation(
  $uuid: UUID!
) {
  removeFileToVerify(uuid: $uuid)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "removeFileToVerify",
            "args": [
                {
                    "kind": "Variable",
                    "name": "uuid",
                    "variableName": "uuid"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UploadFiles_RemoveMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "UploadFiles_RemoveMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "UploadFiles_RemoveMutation",
            "id": null,
            "text": "mutation UploadFiles_RemoveMutation(\n  $uuid: UUID!\n) {\n  removeFileToVerify(uuid: $uuid)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f4efcea3cc3361108ac6c386c0ed84b3';
export default node;
